import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
// import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import styled from 'styled-components';
import { Skeleton, Pagination, Select } from 'antd';
import { Rnd } from 'react-rnd';
import { examsDistrictAdminLogo, reportsDistrictAdminLogo } from 'utils/assets/imageConstant/cloudflare';
import ProficiencyExamEyePopUpModal from './ProficiencyGraph/ProficiencyExamEyePopUpModal';
import StandardExamEyePopUpModal from './StandardGraph/StandardExamEyePopUpModal';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { handleGetSupportNeedList, handleGetSupportNeedListProficiency, handleGetTeacherSubmissionDetails, handleGetTeacherSubmissionDetailsProficiency } from 'store/standardexams';
import { useDispatch } from 'react-redux';
import { useCurrentUser } from 'store/users/selectors';
import { Grid } from '@mui/material';
import { useCurrentClass } from 'store/classes/selectors';
import { useCurrentOrg } from 'store/organizations/selectors';
import { useMobileDetect, useTabletDetection } from 'containers/chat/hooks';

const MOBILE_BOTTOM_NAV_OFFSET_FALLBACK = 58;

const getMobileBottomNavOffset = () => {
  if (typeof document === 'undefined') return MOBILE_BOTTOM_NAV_OFFSET_FALLBACK;
  const footer = document.getElementById('bottomContnrRemove');
  if (!footer) return MOBILE_BOTTOM_NAV_OFFSET_FALLBACK;
  const height = footer.offsetHeight || footer.getBoundingClientRect().height;
  return height > 0 ? Math.ceil(height) : 0;
};

const getReportSupportFlagRndDefaults = (isMobileViewport, footerOffset = 0) => {
  if (typeof window === 'undefined') {
    return { x: 80, y: 120, width: 340 };
  }
  const panelW = isMobileViewport
    ? Math.min(340, window.innerWidth - 24)
    : Math.min(Math.max(window.innerWidth * 0.28, 280), 420);
  const viewportHeight = isMobileViewport
    ? window.innerHeight - footerOffset
    : window.innerHeight;
  return {
    x: Math.max(8, Math.round((window.innerWidth - panelW) / 2)),
    y: Math.max(64, Math.round(viewportHeight * 0.12)),
    width: panelW,
  };
};

const FlagModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: ${({ $footerOffset = 0 }) => $footerOffset}px;
  background: rgba(0, 0, 0, 0.45);
  pointer-events: auto;
`;

const FlagPortalSurface = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: ${({ $footerOffset = 0, $isMobile }) => ($isMobile ? $footerOffset : 0)}px;
  z-index: 2147483000;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`;

const FlagModalMobileCenter = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: ${({ $footerOffset = 0 }) => $footerOffset}px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
  pointer-events: none;
  z-index: 2147483001;

  & > * {
    pointer-events: auto;
  }
`;

const ReportSupportFlagDragPanel = styled.div`
  position: relative;
  width: ${({ $isMobile }) => ($isMobile ? 'min(340px, calc(100vw - 24px))' : 'min(420px, 28vw)')};
  max-width: calc(100vw - 24px);
  min-width: ${({ $isMobile }) => ($isMobile ? '0' : '280px')};
  background: linear-gradient(90deg, #000000, #3533cd);
  border-radius: 13px;
  border: 1px solid #000;
  padding: 20px;
  box-sizing: border-box;
  user-select: none;
  -webkit-user-select: none;

  ${({ $isMobile }) =>
    !$isMobile &&
    `
    cursor: grab;
    touch-action: none;

    &:active {
      cursor: grabbing;
    }
  `}
`;

const ReportSupportFlagModalBody = ({ isMobile, flagData, onClose }) => (
  <div style={{ position: 'relative' }}>
    <div
      className="report-support-flag-modal-close"
      style={{
        position: 'absolute',
        top: 8,
        right: 8,
        zIndex: 10,
        cursor: 'pointer',
        backgroundColor: 'red',
        borderRadius: '100%',
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CloseIcon
        onTouchStart={(e) => { e.stopPropagation(); onClose(); }}
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        style={{ width: 20, height: 20, color: 'white' }}
      />
    </div>
    <ReportSupportFlagDragPanel
      $isMobile={isMobile}
      className={isMobile ? undefined : 'report-support-flag-drag-panel'}
    >
      <p style={{ fontSize: '20px', fontWeight: '600', color: '#fff', margin: '0px', paddingRight: 32 }}>Flag System</p>
      <ul style={{ margin: 0, padding: 0 }}>
        {flagData.map((item, index) => (
          <li key={index} style={{ margin: 0, color: '#fff', fontSize: 14, fontWeight: 600, marginLeft: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ width: 18, height: 18, borderRadius: 3, background: item.backgroundcolor, flexShrink: 0 }} />
              <span style={{ flex: 1 }}>{item.title}</span>
            </div>
          </li>
        ))}
      </ul>
    </ReportSupportFlagDragPanel>
  </div>
);

const EyeIcon = ({ style }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" style={style}>
    <path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      d="M2.458 12C3.732 7.943 7.523 5 12 5s8.268 2.943 9.542 7c-1.274 4.057-5.065 7-9.542 7s-8.268-2.943-9.542-7z" />
    <circle cx="12" cy="12" r="3" strokeWidth="2" />
  </svg>
);



const data = [
  { name: "Nov High",  value: 10 },
  { name: "Int Low", value: 12 },
  { name: "Int Mid",value: 15 },
  { name: "Int High",value: 25 },
  { name: "Adv Low",value: 35 },
  { name: "Adv Mid",value: 50 },
  { name: "Adv High",value: 60 },
];


const domainData = [
  { name: "Listening",  value: 8 },
  { name: "Speaking",value: 6 },
  { name: "Reading", value: 4 },
  { name: "Writing",  value: 2 },
];


  const standardNeedingSupportData = [
    { name: "RL.6.2",  value: 5 },
    { name: "RL.6.3",value: 3 },
    { name: "W.6.1", value: 1 },
  ];


  const standardExamDetails = [
    {
      title: 'Juan Diaz',
      school: 'Mountain Elementary',
      proprity: 'Urgent Support',
      priorityColor: '#df0d14',
    },
    {
      title: 'Claudia Martínez',
      school: 'Memorial High School',
      proprity: 'Needs Attention',
      priorityColor: '#7b13c3',
    },
    {
      title: 'Maria Marco',
      school: 'Mountain Elementary',
      proprity: 'On Track',
      priorityColor: '#078247',
    },
  ];

const FilterToolbar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
`;

const DownloadAction = styled.div`
  cursor: pointer;
  display: block;

  @media (max-width: 768px) {
    width: 100%;

    > div {
      width: 100%;
    }
  }
`;

const FilterSelectWrap = styled.div`
  .ant-select {
    width: 200px;
    margin-left: 10px;
  }

  @media (max-width: 768px) {
    width: 100%;

    .ant-select {
      width: 100% !important;
      margin-left: 0 !important;
    }
  }
`;

const ExamReportSupport = ({redirectTo, flagData, flagEyeModal, from, activeSession, selectedClassId, onDataLoaded, onDownload}) => {
  const showAlert = useAlert();
  const [needHelpData, setNeedHelpData] = useState([]);
  const [needSupportConfidence, setNeedSupportConfidence] = useState({
    offeset: 0,
    total: 0,
    is_loading: false,
  });
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const currentOrg = useCurrentOrg();
  const currentClass = useCurrentClass();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [priorityFilter, setPriorityFilter] = useState('all');

  const isTablate = useTabletDetection();
  const isMobile = useMobileDetect() && !isTablate;
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [flagModalOpen, setFlagModalOpen] = useState(false);
  const [mobileFooterOffset, setMobileFooterOffset] = useState(MOBILE_BOTTOM_NAV_OFFSET_FALLBACK);
  const flagRndDefaults = useMemo(
    () => getReportSupportFlagRndDefaults(isMobile, mobileFooterOffset),
    [isMobile, mobileFooterOffset]
  );
  const openFlagModalOpen = useCallback(() => {
    setFlagModalOpen(true);
  }, []);
  const closeFlagModalOpen = useCallback(() => {
    setFlagModalOpen(false);
  }, []);

  useEffect(() => {
    if (!flagModalOpen || !isMobile) return undefined;
    const updateFooterOffset = () => setMobileFooterOffset(getMobileBottomNavOffset());
    updateFooterOffset();
    window.addEventListener('resize', updateFooterOffset);
    window.addEventListener('orientationchange', updateFooterOffset);
    return () => {
      window.removeEventListener('resize', updateFooterOffset);
      window.removeEventListener('orientationchange', updateFooterOffset);
    };
  }, [flagModalOpen, isMobile]);
  const toggleModalOpen = () => {
    setModalOpen(!modalOpen);
    if (modalOpen) {
      setSelectedTeacher(null);
      setFlagModalOpen(false);
    }
  };

  const handleEyeIconClick = (teacher) => {
    setSelectedTeacher(teacher);
    setModalOpen(true);
  };

  const fetchNeedHelpData = useCallback(async () => {
    try {
      if(!activeSession) {
        return;
      }
      setNeedSupportConfidence(prev => ({
        ...prev,
      is_loading: true,
      }));
      let response = null;
      if(from === 'standard') {
        response = await dispatch(handleGetSupportNeedList(currentUser.orgId , activeSession))
      } else if(from === 'proficiency') {
        const payload = {
          orgId: currentUser?.role == 'teacher' ? currentOrg?.parentId : currentOrg?.id,
          session: activeSession,
        }
        if (currentUser?.role == 'teacher') {
          payload.teacher_id = currentUser?.id;
          payload.class_id = selectedClassId || currentClass?.id;
        }
        response = await dispatch(handleGetSupportNeedListProficiency(payload))
      }
      if (response?.success) {
        if (response?.data?.length > 0) {
          const sortedData = response?.data
            .sort((a, b) => (a.averageGrade || 0) - (b.averageGrade || 0))
            .map(item => ({
              ...item,
              teacherId: currentUser?.role == 'teacher' ? currentUser?.id : (item.teacherId || item.teacher_id),
              priorityColor: item.averageGrade >= 80 ? '#078247' : item.averageGrade >= 60 ? '#7b13c3' : '#df0d14',
              proprity: item.averageGrade >= 80 ? 'On Track' : item.averageGrade >= 60 ? 'Needs Attention' : 'Urgent Support',
              title: `${item.firstName} ${item.lastName}`,
              school: currentUser?.role == 'teacher' ? currentOrg?.displayName : (item?.schoolName?.trim() || item?.school?.trim() || ""),
              schoolName: item?.schoolName || "",
              noOfAssignments: item.uniqueAssignments,
            }));
          setNeedHelpData(sortedData);
          setCurrentPage(1);
          setNeedSupportConfidence(prev => ({
            ...prev,
            is_loading: false,
            offeset: 0,
            total: sortedData.length,
          }));
          if (onDataLoaded) {
            onDataLoaded(sortedData);
          }
        } else {
          setNeedHelpData([]);
          setNeedSupportConfidence(prev => ({
            ...prev,
            is_loading: false,
            offeset: 0,
            total: 0,
          }));
          if (onDataLoaded) {
            onDataLoaded([]);
          }
        }
      } else {
        showAlert(response?.error, 'warning');
      }
    } catch (error) {
      console.error('Error fetching need help data:', error);
      showAlert('Error loading need help data');
    } finally {
      setNeedSupportConfidence(prev => ({
        ...prev,
        is_loading: false,
      }));
    }
  }, [activeSession, currentUser?.orgId, currentUser?.role, currentUser?.id, currentClass?.id, selectedClassId, dispatch, from, showAlert]);

  useEffect(() => {
    setModalOpen(false);
    setSelectedTeacher(null);
    setFlagModalOpen(false);
    setCurrentPage(1);
  }, [selectedClassId]);

  useEffect(() => {
    fetchNeedHelpData();
  }, [from, fetchNeedHelpData, activeSession, selectedClassId]);

  const filteredData = useMemo(() => {
    if (priorityFilter === 'all') {
      return needHelpData;
    }
    return needHelpData.filter(item => item.proprity === priorityFilter);
  }, [needHelpData, priorityFilter]);

  const getPaginatedData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [priorityFilter]);



  
  return (
        <>
        <div className="flex flex-col flex-wrap items-center" style={{padding:'20px', gap:'10px'}}>

        <Grid container spacing={2} sx={{width: '100%', display:'flex', justifyContent:'space-between'}} >
          {currentUser?.role != 'teacher' && (
            <>
          <Grid size={{ xs: 6, md: 6, lg: 4 }}>
                <Link to={flagEyeModal === 'standardExamModal' ? '/standard-based-exam' : '/exams'} style={{ display: "block", flex: "1", minWidth: "33%", textDecoration: "none" }}>
                  <div
                      style={{
                      background: "linear-gradient(90deg, #00adef, #3871c1)",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "8px",
                      fontSize: "16px",
                      fontWeight: 700,
                      color: "#fff",
                      cursor: "pointer",
                      gap: '5px'
                      }}
                  >
                      <img src={examsDistrictAdminLogo} alt="exams" style={{width: '30px', height: '30px'}} />
                      Exams
                  </div>
                </Link>
          </Grid>
          <Grid size={{ xs: 6, md: 6, lg: 4 }}>
          <Link to={redirectTo} style={{ display: "block", flex: "1", minWidth: "33%", textDecoration: "none" }}>
                  <div
                      style={{
                      background: "linear-gradient(90deg, #00adef, #3871c1)",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "8px",
                      fontSize: "16px",
                      fontWeight: 700,
                      color: "#fff",
                      cursor: "pointer",
                      gap:'5px',
                      }}
                  >
                      <img src={reportsDistrictAdminLogo} alt="exams" style={{width: '30px', height: '30px'}} />
                      Reports
                  </div>
                </Link>
          </Grid>
          <Grid size={{ xs: 6, md: 6, lg: 4 }}>
          {onDownload && (
                <div onClick={onDownload} style={{ display: "block", cursor: "pointer" }}>
                  <div
                    style={{
                      background: "linear-gradient(90deg, #00adef, #3871c1)",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "8px 14px",
                      fontSize: "15px",
                      fontWeight: 700,
                      color: "#fff",
                      cursor: "pointer",
                      gap: "2px",
                    }}
                  >
                    <FileDownloadIcon sx={{ width: "25px", height: "25px", color: "#fff" }} />
                    Download
                  </div>
                </div>
              )}
          </Grid>
            </>
          )}
          </Grid>
            
              {
                flagEyeModal == "standardExamModal" ? (
                  modalOpen && (
                    <StandardExamEyePopUpModal 
                      teacher={selectedTeacher}
                      toggleModalOpen={toggleModalOpen} 
                      openFlagModalOpen={openFlagModalOpen}
                      dispatch={dispatch}
                      handleGetTeacherSubmissionDetails={handleGetTeacherSubmissionDetails}
                    />
                   )
                ): (
                  modalOpen && (
                    <ProficiencyExamEyePopUpModal 
                      teacher={selectedTeacher}
                      toggleModalOpen={toggleModalOpen} 
                      modalOpen={modalOpen} 
                      data={domainData} 
                      openFlagModalOpen={openFlagModalOpen}
                      dispatch={dispatch}
                      handleGetTeacherSubmissionDetailsProficiency={handleGetTeacherSubmissionDetailsProficiency}
                      session={activeSession}
                      selectedClassId={selectedClassId}
                    />
                   )
                )
              
            }
            {
              flagModalOpen && typeof document !== 'undefined' && createPortal(
                <FlagPortalSurface $isMobile={isMobile} $footerOffset={mobileFooterOffset}>
                  {isMobile && (
                    <>
                      <FlagModalBackdrop $footerOffset={mobileFooterOffset} onClick={closeFlagModalOpen} />
                      <FlagModalMobileCenter $footerOffset={mobileFooterOffset}>
                        <ReportSupportFlagModalBody
                          isMobile={isMobile}
                          flagData={flagData}
                          onClose={closeFlagModalOpen}
                        />
                      </FlagModalMobileCenter>
                    </>
                  )}
                  {!isMobile && (
                    <Rnd
                      default={flagRndDefaults}
                      bounds="window"
                      enableResizing={false}
                      dragHandleClassName="report-support-flag-drag-panel"
                      cancel=".report-support-flag-modal-close,.report-support-flag-modal-close *"
                      style={{ pointerEvents: 'auto', zIndex: 2147483001 }}
                    >
                      <ReportSupportFlagModalBody
                        isMobile={isMobile}
                        flagData={flagData}
                        onClose={closeFlagModalOpen}
                      />
                    </Rnd>
                  )}
                </FlagPortalSurface>,
                document.body,
              )
            }
            <div style={{background:'linear-gradient(90deg, #00adef, #3871c1)', borderRadius:'12px', display:'grid', gridTemplateColumns:'minmax(0, 2fr) minmax(0, 2fr) minmax(0, 1fr)', alignItems:'center', padding:'6px 16px',  fontSize:'14px', fontWeight:'600', color:'#fff', width:'100%'}}>
                    <p className="teacherNeeded" style={{margin:'0px', textAlign:'left'}}>{currentUser?.role == 'teacher' ? 'Students Needing Support' : 'Teachers Needing Support'}</p>
                    <p style={{margin:'0px', textAlign:'left'}}>Result</p>
                    <p style={{margin:'0px', textAlign:'left'}}>No. of Section Assigned</p>
            </div>
            <FilterToolbar>
            {onDownload && currentUser?.role === 'teacher' && (
                <DownloadAction onClick={onDownload}>
                  <div
                    style={{
                      background: "linear-gradient(90deg, #00adef, #3871c1)",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "8px 14px",
                      fontSize: "15px",
                      fontWeight: 700,
                      color: "#fff",
                      cursor: "pointer",
                      gap: "2px",
                    }}
                  >
                    <FileDownloadIcon sx={{ width: "25px", height: "25px", color: "#fff" }} />
                    Download
                  </div>
                </DownloadAction>
              )}
              <FilterSelectWrap>
                <Select
                  value={priorityFilter}
                  onChange={setPriorityFilter}
                  placeholder="Filter by Priority"
                >
                  <Select.Option value="all">All</Select.Option>
                  <Select.Option value="Urgent Support">Urgent Support</Select.Option>
                  <Select.Option value="Needs Attention">Needs Attention</Select.Option>
                  <Select.Option value="On Track">On Track</Select.Option>
                </Select>
              </FilterSelectWrap>
            </FilterToolbar>
            <div style={{padding:'20px', border:'2px solid #e8e8e8', borderRadius:'20px', width:'100%'}}>
                {needSupportConfidence.is_loading ? (
                  [...Array(3)].map((_, index) => (
                    <div key={index} style={{display: "grid", gridTemplateColumns:'minmax(0, 2fr) minmax(0, 2fr) minmax(0, 1fr)', alignItems: "center", borderBottom: "1px solid #e8e8e8", paddingBottom: "10px", marginBottom: "10px"}}>
                      <div style={{minWidth: 0}}>     
                        <Skeleton active paragraph={{ rows: 1, width: '60%' }} title={false} />
                        <Skeleton active paragraph={{ rows: 1, width: '40%' }} title={false} style={{ marginTop: 4 }} />
                      </div>
                      <div style={{ display: "flex", alignItems: "center", columnGap: 4, justifyContent: "center" }}>
                        <Skeleton.Button active size="small" style={{ width: 20, height: 20 }} />
                        <Skeleton active paragraph={{ rows: 1, width: 80 }} title={false} />
                      </div>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", columnGap: 4 }}>
                        <Skeleton active paragraph={{ rows: 1, width: 30 }} title={false} />
                      </div>
                    </div>
                  ))
                ) : getPaginatedData().length === 0 ? (
                  <div style={{display: "flex", justifyContent: "center", alignItems: "center", padding: "40px"}}>
                    <p style={{fontSize: 16, fontWeight: 500, color: "#9CA3AF", margin: 0}}>{currentUser?.role == 'teacher' ? 'No student available' : 'No teacher available'}</p>
                  </div>
                ) : (
                  getPaginatedData().map((item, index) => (
                    <div key={index} style={{display: "grid", gridTemplateColumns:'minmax(0, 2fr) minmax(0, 2fr) minmax(0, 1fr)', alignItems: "center", borderBottom: "1px solid #e8e8e8", paddingBottom: "10px"}}>
                      <div style={{minWidth: 0}}>     
                        <p style={{fontSize: 14, fontWeight: 600, color: "#111827", margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal", wordBreak: "break-word"}}>{item.title}</p>
                        <div style={{fontSize: 10, color: "#9CA3AF", marginTop: 0}}>{item.school}</div>
                      </div>

                      <div style={{ display: "flex", alignItems: "center", columnGap: 4 }}>
                        <button onClick={() => handleEyeIconClick(item)}  style={{backgroundColor: "transparent", border: "none", cursor: "pointer", padding: 0, display: "flex", alignItems: "center"}} aria-label="View">
                            <EyeIcon style={{width: 20, height: 20, color: "black"}} />
                        </button>
                        <CheckCircleRoundedIcon sx={{color: "#3871c1", width: 15, height: 15}} />
                        <span style={{fontSize: 14, fontWeight: 600, color: item.priorityColor, marginLeft: 2}}>{item.proprity}</span>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", columnGap: 4 }}>
                        <span style={{fontSize: 14, fontWeight: 600, color: "#000", marginLeft: 2}}>{item.noOfAssignments}</span>
                      </div>
                      
                    </div>
                  ))
                )}
                {!needSupportConfidence.is_loading && filteredData.length > 0 && (
                  <div style={{display: "flex", justifyContent: "center", marginTop: "20px"}}>
                    <Pagination
                      current={currentPage}
                      pageSize={itemsPerPage}
                      total={filteredData.length}
                      onChange={(page) => setCurrentPage(page)}
                      showSizeChanger={false}
                    />
                  </div>
                )}

                


            </div>
        </div>
        </>
  )
}

export default ExamReportSupport;
